import Cookies from 'js-cookie';
import {
    AUTH_TOKEN_COOKIE_NAME,
    AUTH_TOKEN_DEALER_COOKIE_NAME,
} from 'lib/constants';

class AuthTokenService {
    public removeToken() {
        Cookies.remove(AUTH_TOKEN_COOKIE_NAME);
        Cookies.remove(AUTH_TOKEN_DEALER_COOKIE_NAME);
    }

    public getToken() {
        const token = Cookies.get(AUTH_TOKEN_COOKIE_NAME);
        const dealerToken = Cookies.get(AUTH_TOKEN_DEALER_COOKIE_NAME);

        return token || dealerToken;
    }

    public setToken({token, isDealer}: {token: string; isDealer: boolean}) {
        if (isDealer) {
            Cookies.set(AUTH_TOKEN_DEALER_COOKIE_NAME, token);
            return;
        }

        Cookies.set(AUTH_TOKEN_COOKIE_NAME, token);
    }
}

export const AuthTokenProvider = new AuthTokenService();
